import React, { useEffect, useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { FormGroup, Label } from "reactstrap";

const CustomPaginatedSelect = ({
  label,
  name,
  value,
  onChange,
  disabled = false,
  placeholder = "Select an option",
  staticOptions = [],
  isMulti = false,
  loadOptions,
  onBlur,
  touched,
  errors,
  isSearchable = true,
  colorCode = "rgba(255, 255, 255, 0.8)",
  dropdownIndicatorDisplay = "block",
  isClearable = false,
  key = name,
  enableFilter = false,
  hideRemoveIcon = false,
}) => {
  const [isLightMode, setIsLightMode] = useState(
    document.body.classList.contains("white-content")
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsLightMode(document.body.classList.contains("white-content"));
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, [isLightMode]);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: "0.4285rem",
      border: state.isFocused
        ? "1px solid #1d8cf8"
        : isLightMode
        ? "1px solid rgba(29, 37, 59, 0.5)"
        : "1px solid #2b3553",
      backgroundColor: "transparent",
      outline: "none",
      boxShadow: "none",
      fontFamily: "Poppins, sans-serif",
      fontWeight: 400,
      color: isLightMode ? "rgba(34, 42, 66, 0.4)" : "#6c757c",
      fontSize: "0.7500000025rem",

      "&:hover": {
        borderColor: state.isFocused ? "#1d8cf8" : "#2b3553",
      },
    }),
    input: (base) => ({
      ...base,
      color: isLightMode ? "#222a42" : colorCode,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#4A90E2",
      fontFamily: "Poppins, sans-serif",
      fontSize: "0.7500000025rem",
      fontWeight: 400,
      color: isLightMode ? "rgba(34, 42, 66, 0.4)" : "#6c757c",
      display: dropdownIndicatorDisplay,

      "&:hover": {
        color: isLightMode ? "rgba(34, 42, 66, 0.7)" : "#656f77d6",
      },
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: "none",
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#ddd",
      borderRadius: "0.4285rem",
      boxShadow: "none",
      fontFamily: "Poppins, sans-serif",
      fontSize: "0.7500000025rem",
      fontWeight: 400,
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      transition: "all 150ms linear",
      paddingLeft: "1.5rem",
      paddingRight: "1.5rem",
      display: "block",
      outline: "none",
      backgroundColor: isSelected ? "#ddd" : isFocused ? "#ddd" : "#fff",
      color: isSelected ? "#000" : "#333",
      fontFamily: "Poppins, sans-serif",
      fontSize: "0.7500000025rem",
      fontWeight: 400,

      "&:hover": {
        backgroundColor: "#f5f5f5",
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: isLightMode ? "rgba(34, 42, 66, 0.4)" : "#6c757c",
      fontFamily: "Poppins, sans-serif",
      fontSize: "0.7500000025rem",
      fontWeight: 400,
    }),
    singleValue: (base) => ({
      ...base,
      color: isLightMode ? "#222a42" : colorCode,
      fontWeight: "bold",
      fontFamily: "Poppins, sans-serif",
      fontSize: "0.7500000025rem",
      fontWeight: 400,
      fontFamily: "Poppins, sans-serif",
    }),
  };
  return (
    <div className="custom_input_field">
      <FormGroup>
        {label && (
          <Label className="d-block w-100 mb-0 text-capitalize">{label}</Label>
        )}
        <AsyncPaginate
          key={key}
          isClearable={isClearable}
          isMulti={isMulti}
          isSearchable={isSearchable}
          isDisabled={disabled}
          classNamePrefix="react-select"
          name={name}
          placeholder={placeholder}
          value={value}
          loadOptions={loadOptions || undefined}
          options={loadOptions ? undefined : staticOptions}
          shouldLoadMore={(scrollHeight, clientHeight, scrollTop) => {
            return loadOptions ? scrollHeight - scrollTop < 301 : false;
          }}
          onChange={(selectedOption) => {
            onChange(selectedOption || null);
          }}
          filterOption={
            enableFilter
              ? (option, rawInput) =>
                  option.label.toLowerCase().includes(rawInput.toLowerCase())
              : undefined
          }
          onBlur={onBlur}
          styles={customStyles}
          components={{
            ...(hideRemoveIcon && {
              MultiValueRemove: () => null,
            }),
          }}
        />
      </FormGroup>
      {touched?.[name] && errors?.[name] && (
        <span className="error text-danger">{errors?.[name]}</span>
      )}
    </div>
  );
};

export default CustomPaginatedSelect;
